import {VideoPlayingServiceBase} from "./video-playing-service-base";
import {GameInfo} from "../games/game-info";
import {IVideoPlayer} from "./video-players/video-player.interface";

export class StaticVideoPlayingService extends VideoPlayingServiceBase {

    public gaCategory = "VIDEO-LIST";

    protected async _checkIfSupported() {
        return Promise.resolve(true);
    }

    async getVideoPlayer(gameInfo: GameInfo, videoReference: HTMLVideoElement, dontAutoSwipe?: boolean): Promise<IVideoPlayer> {

        const gameType = gameInfo.gameType;

        const streamSource = gameInfo.videoURL;

        const StaticVideoPlayer = await import("./video-players/static-video-player/static-video-player").then(module => module.StaticVideoPlayer);

        // Maybe add check like in live stream player: if ! player.supported, return null.

        return new StaticVideoPlayer('StaticVideoPlayer', gameType, videoReference, streamSource, this.services, dontAutoSwipe);

    }
}
